import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const stop: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M12-10.5v11c0 .133-.055.25-.156.344A.46.46 0 0 1 11.5 1H.5A.5.5 0 0 1 .14.844.47.47 0 0 1 0 .5v-11q0-.201.14-.344A.5.5 0 0 1 .5-11h11c.133 0 .25.055.344.156.101.094.156.211.156.344m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11)"
    />
  ),
  svgProps: {
    height: "12",
    width: "12",
  }
};

export const stopCircle: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M8.5-2.75v-4.5a.22.22 0 0 0-.078-.172.22.22 0 0 0-.172-.078h-4.5a.26.26 0 0 0-.187.078.23.23 0 0 0-.063.172v4.5q0 .111.063.188.075.063.187.062h4.5q.106 0 .172-.062A.26.26 0 0 0 8.5-2.75m2.688-5.266Q11.998-6.64 12-5q-.002 1.628-.812 3.016A5.9 5.9 0 0 1 9.016.188 5.85 5.85 0 0 1 6 1 5.9 5.9 0 0 1 2.984.188 5.95 5.95 0 0 1 .797-1.984 5.95 5.95 0 0 1 0-5a5.91 5.91 0 0 1 2.984-5.187A5.9 5.9 0 0 1 6-11q1.64.001 3.016.813a5.9 5.9 0 0 1 2.172 2.171m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11)"
    />
  ),
  svgProps: {
    height: "12",
    width: "12",
  }
};

export const stopCircleOutline: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M2.984-10.187A5.9 5.9 0 0 1 6-11q1.64.001 3.016.813a5.9 5.9 0 0 1 2.172 2.171Q11.998-6.64 12-5q-.002 1.628-.812 3.016A5.9 5.9 0 0 1 9.016.188 5.85 5.85 0 0 1 6 1 5.9 5.9 0 0 1 2.984.188 5.95 5.95 0 0 1 .797-1.984 5.95 5.95 0 0 1 0-5a5.91 5.91 0 0 1 2.984-5.187m.875 8.875A4.23 4.23 0 0 0 6-.75q1.154 0 2.125-.562A4.2 4.2 0 0 0 9.672-2.86 4.17 4.17 0 0 0 10.25-5q-.002-1.154-.578-2.125a4.1 4.1 0 0 0-1.547-1.547A4.1 4.1 0 0 0 6-9.25a4.17 4.17 0 0 0-2.14.578 4.2 4.2 0 0 0-1.547 1.547A4.17 4.17 0 0 0 1.75-5q0 1.158.563 2.14a4.3 4.3 0 0 0 1.546 1.548M3.75-2.5a.28.28 0 0 1-.187-.062.28.28 0 0 1-.063-.188v-4.5q0-.106.063-.172A.26.26 0 0 1 3.75-7.5h4.5q.106 0 .172.078.076.066.078.172v4.5a.26.26 0 0 1-.078.188.23.23 0 0 1-.172.062zm0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11)"
    />
  ),
  svgProps: {
    height: "12",
    width: "12",
  }
};
